<template>
  <div>
    <b-container fluid class="settings-container">
      <b-row class="justify-content-center">
        <b-col lg="8">
          <b-breadcrumb>
            <b-breadcrumb-item to="/app/settings">Settings</b-breadcrumb-item>
            <b-breadcrumb-item active>
              {{ this.$route.meta.readableName }}
            </b-breadcrumb-item>
          </b-breadcrumb>
          <fade-transition :duration="200" origin="center top" mode="out-in">
            <router-view></router-view>
          </fade-transition>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";

export default {
  components: {
    FadeTransition
  }
};
</script>
<style>
.settings-container {
  background-color: #f6f9fc;
  padding-top: 45px;
}
</style>
